import React from 'react';
import classnames from 'classnames';
import { ReactComponent as MsgShapes } from 'v2/icons/msg-shapes.svg';
import styles from './unqualifiedMsg.module.scss';

const UnqualifiedMsg = () => {
  return (
    <div
      className={classnames(
        styles.unqualifiedMsg,
        styles.listContainer,
        'position-relative'
      )}
    >
      <div className={classnames(styles.msgContainer)}>
        <h1>Sorry!</h1>
        <p>
          Unfortunately you don&apos;t meet our qualifications to use free
          search. We currently only support qualified corporate data buyers. If
          you have any questions you can contact us at
          <a className={styles.email} href={'mailto:hello@nomad-data.com'}>
            {' '}
            hello@nomad-data.com
          </a>
        </p>
      </div>
      <MsgShapes className="h-100" />
    </div>
  );
};

export default UnqualifiedMsg;
